var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-container"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"course-create"},[_c('editor'),_vm._v(" "),_c('a',{staticClass:"create",attrs:{"role":"button"},on:{"click":_vm.saveCourse}},[_c('div',{staticClass:"symbol"},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"create-text"},[_vm._v("添加课程")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df03868","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/course/Create.vue
// module id = null
// module chunks = 